import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonFilterComponent } from './button-filter.component';
import { SharedModule } from '../shared/shared.module';



@NgModule({
  declarations: [ButtonFilterComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [ButtonFilterComponent]
})
export class ButtonFilterModule { }
